var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLocation = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "location",
    transform: "translate(12070 -19354)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_646",
    "data-name": "Rectangle 646",
    width: 32,
    height: 32,
    transform: "translate(-12070 19354)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "map-pin",
    transform: "translate(-12063.856 19358.008)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4965",
    "data-name": "Path 4965",
    d: "M17.713,8.356c0,5.722-7.356,10.626-7.356,10.626S3,14.078,3,8.356a7.356,7.356,0,1,1,14.713,0Z",
    transform: "translate(-0.144 -0.008)",
    fill: "none",
    stroke: "#2884ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_86",
    "data-name": "Ellipse 86",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(7.856 5.991)",
    fill: "none",
    stroke: "#2884ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_166",
    "data-name": "Line 166",
    y2: 4,
    transform: "translate(10.356 18.992)",
    fill: "none",
    stroke: "#2884ff",
    strokeWidth: 2
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLocation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/location.42eb2ddf97ff2e7b3b720972dff0e27a.svg";